import React from 'react';
import {NextSeo} from 'next-seo';
import NewsNavDetailsPromotion from '@components/NewsPromotion/NewsNavDetailsPromotion';
import NewsTNHDetails from '@components/NewsTNHDetails/NewsTNHDetails';
import { BookingProvider } from '@contexts/BookingContext';

export default function UuDaiDetailsPages(props) {
    const {seoPage} = props;
    
    return (
        <BookingProvider>
            {seoPage && <NextSeo {...seoPage} />}
            <div>
                <NewsNavDetailsPromotion news={props.preloadedNews} />
                <NewsTNHDetails {...props} />
            </div>
        </BookingProvider>
    );
}
